var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{stroke:#dadada;stroke-width:2px;}.c{fill:#efefef;}.d{fill:#1b1c1d;}.e{fill:#fdfdfd;}.f{stroke:none;}.g{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 29,
    cy: 29,
    r: 29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 29,
    cy: 29,
    r: 28
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.605 18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.418 0.413)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M167.383,118.142H151.1v3.247h2.129v17.045h16.283v-18.34A2.046,2.046,0,0,0,167.383,118.142Z",
    transform: "translate(-151.1 -118.142)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.1 0.413)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M342.381,118.142h-1.006v20.292h3.135v-18.34A2.047,2.047,0,0,0,342.381,118.142Z",
    transform: "translate(-341.375 -118.142)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.994 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M164.784,134.119H148.5a.4.4,0,0,1-.413-.38V117.018h-1.717a.4.4,0,0,1-.413-.38v-3.258a.4.4,0,0,1,.413-.38h16.283a2.449,2.449,0,0,1,2.542,2.338v18.4A.4.4,0,0,1,164.784,134.119Zm-15.871-.759h15.458v-18.02a1.654,1.654,0,0,0-1.716-1.578h-15.87v2.5H148.5a.4.4,0,0,1,.413.38Z",
    transform: "translate(-145.958 -113.001)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.652 3.534)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M216.438,161.845h-11.11a.413.413,0,1,1,0-.826h11.11a.413.413,0,0,1,0,.826Z",
    transform: "translate(-204.915 -161.019)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.652 7.066)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M216.438,209.832h-11.11a.413.413,0,1,1,0-.826h11.11a.413.413,0,0,1,0,.826Z",
    transform: "translate(-204.915 -209.006)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.652 10.598)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M216.438,257.819h-11.11a.413.413,0,1,1,0-.826h11.11a.413.413,0,0,1,0,.826Z",
    transform: "translate(-204.915 -256.993)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.652 14.129)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M216.438,305.806h-11.11a.413.413,0,1,1,0-.826h11.11a.413.413,0,0,1,0,.826Z",
    transform: "translate(-204.915 -304.98)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.652 17.422)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M216.438,353.793h-11.11a.413.413,0,1,1,0-.826h11.11a.413.413,0,0,1,0,.826Z",
    transform: "translate(-204.915 -352.967)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.534 5.778)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.415 0.415)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 4.818,
    cy: 4.818,
    r: 4.818
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M320.415,207.416a4.821,4.821,0,1,0,4.818-4.818A4.8,4.8,0,0,0,320.415,207.416Z",
    transform: "translate(-320.415 -202.598)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M320.483,207.9a5.233,5.233,0,1,1,5.233-5.233A5.239,5.239,0,0,1,320.483,207.9Zm0-9.64a4.407,4.407,0,1,0,4.407,4.407A4.412,4.412,0,0,0,320.483,198.259Z",
    transform: "translate(-315.25 -197.433)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.542 0.413)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M102.319,118.142a2.129,2.129,0,0,0-2.129,2.129v11.7H98.06V134.3h6.388V120.271A2.129,2.129,0,0,0,102.319,118.142Z",
    transform: "translate(-98.06 -118.142)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.129)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M99.719,129.981H93.331a.413.413,0,0,1-.413-.413V127.24a.413.413,0,0,1,.413-.413h1.716V115.543a2.542,2.542,0,0,1,5.084,0v14.025A.413.413,0,0,1,99.719,129.981Zm-5.975-.826h5.562V115.543a1.716,1.716,0,0,0-3.433,0v11.7a.413.413,0,0,1-.413.413H93.744v1.5Z",
    transform: "translate(-92.918 -113.001)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.413 10.71)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M73.669,266.005h0a2.129,2.129,0,0,0,2.129-2.129v-2.527H71.54v2.527A2.129,2.129,0,0,0,73.669,266.005Z",
    transform: "translate(-71.54 -261.349)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.284)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M68.94,261.688a2.545,2.545,0,0,1-2.542-2.542v-2.527a.413.413,0,0,1,.413-.413h4.259a.413.413,0,0,1,.413.413v2.527A2.545,2.545,0,0,1,68.94,261.688Zm-1.716-4.656v2.114a1.716,1.716,0,1,0,3.433,0v-2.114Z",
    transform: "translate(-66.398 -256.206)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/bills.d69fa7b2316538be9763c5b01b4b250c.svg";
export { ForwardRef as ReactComponent };